import { render } from "./App.vue?vue&type=template&id=35624d91"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=35624d91&lang=scss"
script.render = render

export default script
import QSpinnerBall from 'quasar/src/components/spinner/QSpinnerBall.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QSpinnerBall});
